import { Stack, Typography } from "@mui/material";
import diverWithSignSuc from "../assets/svgGame/diver_with_sign-suc.svg";
import diverWithSignErr from "../assets/svgGame/diver_with_sign-err.svg";
import { useEffect } from "react";

export default function FeedbackOverlay({ isOpen, setIsOpen, message, isSuccess }) {

    useEffect(() => {
        let timer;
        if (isOpen) {
            timer = setTimeout(() => {
                setIsOpen(false);
            }, isSuccess ? 1500 : 2000);
        }
        return () => clearTimeout(timer);
    }, [isOpen]);

    return (
        <Stack
            sx={{
                position: 'fixed',
                bottom: 0,
                left: '50%',
                transform: `translateX(-50%) translateY(${isOpen ? '0' : '100%'})`,
                p: 2,
                pt: 3,
                zIndex: 9,
                minWidth: 200,
                height: 150,
                transition: 'transform 0.3s ease-in-out',
                backgroundImage: `url(${isSuccess ? diverWithSignSuc : diverWithSignErr})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Stack
                width={220}
                height={85}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Typography
                    align="center"
                    sx={{
                        color: '#fff',
                        fontWeight: "bold",
                        fontSize: '1rem',
                        lineHeight: '1.5rem',
                        borderRadius: '4px',
                    }}
                >
                    {message}
                </Typography>
            </Stack>
        </Stack>
    );
}
